<div class="tech-dismiss-dialog">
    <div class="header">
        <div class="mb-1">
            <div class="font-700 font-error font-18 mb-1">{{'tech-app.alert'|translate}}</div>
            <div class="font-400 font-gray-45 font-15"> {{'tech-app.assigned-service-updated'|translate}},<br> {{'tech-app.review-changes'|translate}}</div>
        </div>
    </div>
    <div class="tech-dismiss-body scrollable">
            <div *ngFor="let alert of unreadAlerts" class="">
                <div class="mb-3">
                    <div class="font-600 font-black font-16 mb-1">{{getTranslatedText(alert.heading)}}</div>
                    <div class="font-400 font-gray-45 font-15"><span>{{ helperService.getLocalizationValue(currentLang, alert, 'text') }}</span></div>
                </div>
        </div>
        
        
        <div class="mb-2">
            <button class="btn btn-border mr-2" (click)="dismissDialog()">
              {{'tech-app.dismiss'|translate}}
            </button>
        </div>
    </div>
</div>